import { translate } from "../../../common/providers";

export const translateFilterLabel = (value) =>
	translate(`commitment-tracking.filter.${value.toLowerCase().replace(/[_ ]/g, "-")}`);

export const translateFilterOptionLabel = (filter, option) => {
	if (!filter || !option) {
		return "";
	}
	return translate(
		`commitment-tracking.filter.${filter.toLowerCase().replaceAll("_", "-")}.${option
			.toLowerCase()
			.replaceAll("_", "-")}`
	);
};
